import React, { Component } from "react";
import Table from "./../common/table";

class OperatorsTable extends Component {

	handleSelectAll = (e) => {
		const { checked } = e.target;
		const { operators, onSelectAll } = this.props;
		
		if (typeof onSelectAll !== 'function') {
			console.error('onSelectAll prop is not a function:', onSelectAll);
			return;
		}
		
		if (checked) {
			// Select all operators
			const allIds = operators.map(operator => operator._id);
			onSelectAll(allIds);
		} else {
			// Deselect all
			onSelectAll([]);
		}
	};

	isAllSelected = () => {
		const { operators, checkedFields = [] } = this.props;
		return operators.length > 0 && operators.every(operator => 
			checkedFields.includes(operator._id)
		);
	};

	getColumns = () => [
		{
			key: "checkbox",
			label: (
				<input
					type="checkbox"
					style={{
						width: "15px",
						height: "15px",
						marginTop: "0.4rem",
						borderRadius: 0,
					}}
					onChange={this.handleSelectAll}
					checked={this.isAllSelected()}
				/>
			),
			content: (operator) => (
				<span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
					<input
						type="checkbox"
						style={{
							width: "15px",
							height: "15px",
							marginTop: "0.4rem",
							borderRadius: 0,
						}}
						onChange={this.props.handleCheckboxChange}
						value={operator._id}
						checked={this.props.checkedFields?.includes(operator._id) || false}
					/>
				</span>
			),
		},
		{
			key: "avatarUsername",
			label: "Username",
			content: (operator) => (
				<div style={{ display: "flex", alignItems: "center" }}>
					<img
						src={operator.operators?.imageSrc || "/default-avatar.png"}
						alt="Avatar"
						style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "10px" }}
						onError={(e) => {
							e.target.src = "/default-avatar.png";
						}}
					/>
					<span>{operator.operators?.username || operator.username || 'N/A'}</span>
				</div>
			),
		},
		
		{
			label: "First Name",
			path: "operators.contactName.first"
		},
		
		{
			label: "Last Name", 
			path: "operators.contactName.last"
		},
		
		{
			label: "Initials",
			path: "operators.contactName.initials"
		},
		
		{
			label: "Email",
			path: "operators.email"
		},
		
		{
			label: "Gender",
			path: "operators.gender"
		},
		
		{
			label: "Date of Birth",
			key: "dateBirth",
			content: (operator) => {
				const dob = operator.operators?.dateBirth;
				return dob ? new Date(dob).toLocaleDateString() : '';
			}
		},
		
		{
			label: "Address",
			key: "address",
			content: (operator) => {
				const addr = operator.operators?.Address;
				if (!addr) return '';
				const parts = [addr.address1, addr.city, addr.state].filter(Boolean);
				return parts.join(', ');
			}
		},
		
		{
			label: "Phone",
			path: "operators.phones.phone"
		},
		
		{
			label: "Mobile",
			path: "operators.phones.mobile"
		},
		
		{
			label: "Business Name",
			key: "businessName",
			content: (operator) => {
				// Check if businessName exists and is not empty
				const businessName = operator.operators?.businessName || 
					   operator.businessName || 
					   operator.companyInfo?.businessName || 
					   operator.operators?.companyInfo?.businessName;
				
				// If business name exists and is not empty, show it
				if (businessName && businessName.trim() !== '') {
					return businessName;
				}
				
				// If we have a businessNo but no populated business name, show a pending message
				if (operator.businessNo) {
					return <span className="text-muted">Pending Population</span>;
				}
				
				// No business association
				return 'N/A';
			}
		},
		
		{
			label: "Department",
			path: "companyInfo.department"
		},
		
		{
			label: "Status",
			key: "status",
			content: (operator) => (
				<span className={`badge ${operator.status === 'active' ? 'badge-success' : 'badge-secondary'}`}>
					{operator.status || ''}
				</span>
			)
		},
	];

	render() {
		const { operators, onSort, sortColumn, checkedFields } = this.props;
		const columns = this.getColumns();
		return (
			<Table
				columns={columns}
				sortColumn={sortColumn}
				onSort={onSort}
				data={operators}
			/>
		);
	}
}

export default OperatorsTable;
